import { render, staticRenderFns } from "./PipeExtractionTongre.vue?vue&type=template&id=56cfb9c6&scoped=true"
import script from "./PipeExtractionTongre.vue?vue&type=script&lang=js"
export * from "./PipeExtractionTongre.vue?vue&type=script&lang=js"
import style0 from "./PipeExtractionTongre.vue?vue&type=style&index=0&id=56cfb9c6&prod&lang=scss"
import style1 from "./PipeExtractionTongre.vue?vue&type=style&index=1&id=56cfb9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cfb9c6",
  null
  
)

export default component.exports